import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
   {
      path: '/',
      redirect: 'motivos-indisponibilidade',
      component: LayoutPadrao,
      children: [
         {
            path: '/motivos-indisponibilidade',
            name: 'motivos-indisponibilidade',
            component: () => import('./pages/ListarMotivosIndisponibilidade.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'motivos-indisponibilidade',
      component: LayoutPadrao,
      children: [
         {
            path: '/motivos-indisponibilidade/:id',
            name: 'motivos-editar',
            component: () => import('./pages/EditarMotivosIndisponibilidade.vue')
         }
      ]
   }
]
